export const onlyNumberNormalizer = (valueLen) => (value) => {
  if (!value) {
    return value;
  }
  let onlyNums = value.replace(/[^\d]/g, "");
  if (valueLen) {
    onlyNums = onlyNums.slice(0, valueLen);
  }
  return onlyNums;
};

export const phone = onlyNumberNormalizer(10);

export const zip = onlyNumberNormalizer(5);

export const OTPNormalizer = onlyNumberNormalizer(1);
